<template>
  <div class="text-block block-card card-border ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="true">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <span class="botter-Weather-icon white--text text-lg-2" />
            </div>

            <h4>
              Weather
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation
            v-if="validData"
          v-model = "errorsCount" >
          <div class="block-card-body">
            <label >Area</label>
            <vTextareaAutocomplete 
              v-model="data.area" 
              :type="'textfield'"
              :validation-rules=" [v => !!v || 'Area is Required']"/>

            <label >Image URL</label>
            <!--                    <v-text-field-->
            <!--                            outline-->
            <!--                            v-model="data.imageUrl"-->
            <!--                            :error="!data.imageUrl || !common.validURL(data.imageUrl)"-->
            <!--                            :error-messages="!data.imageUrl? 'URL is Required':'' || !common.validURL(data.imageUrl)? 'URL is not valid':''"-->
            <!--                    >-->
            <!--                    </v-text-field>-->
            <vTextareaAutocomplete 
              v-model="data.imageUrl" 
              :type="'textfield'"
              :validation-rules=" [v => !!v || 'URL is Required']"/>
            <v-layout row>
              <v-flex 
                xs4 
                class="pl-0">
                <label >Temperature</label>
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.temp"-->
                <!--                                    :error="!data.temp"-->
                <!--                                    :error-messages="!data.temp? 'Temperature is Required':'' "-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.temp" 
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'Temperature is Required']"/>
              </v-flex>
              <v-flex xs4>
                <label >High temperature</label>
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.hiTemp"-->
                <!--                                    :error="!data.hiTemp"-->
                <!--                                    :error-messages="!data.hiTemp? 'High temperature is Required':'' "-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.hiTemp" 
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'High temperature is Required']"/>
              </v-flex>
              <v-flex 
                xs4 
                class="pr-0">
                <label >Low temperature </label>
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.lowTemp"-->
                <!--                                    :error="!data.lowTemp"-->
                <!--                                    :error-messages="!data.lowTemp? 'Low temperature is Required':'' "-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.lowTemp" 
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'Low temperature is Required']"/>
              </v-flex>
            </v-layout>
          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import buttonsList from './common-inner-blocks/button-list'
import common from '../../../../utils/common'
import VueTribute from 'vue-tribute'
import Tribute from 'tributejs'
import FormValidation from '../FormValidation'
export default {
  name: 'TextBlock',
  components: {
    buttonsList,
    VueTribute,
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      buttonsModel: { errorsCount: 0 },
      valid: true,
      panel: 1,
      common
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style scoped>
</style>
